import zhLocale from "element-ui/lib/locale/lang/zh-CN"; // 引入element语言包
import privacyCN from "./privacyCN.js"; //中文隐私政策
const cn = {
  error:{
    msg:'页面出现错误-代码404',
    worry:'不要担心，你可以尝试刷新几次',
    refresh:'刷新页面',
    back:'返回首页'
  },
  loadingText:'拼命加载中',
  publicText: {
    sure: "确定",
    cancel: "取消",
    submit: "提交",
    title: "提示",
    edition: "版本信息",
    txt: "FSOM",
    model: "产品型号",
    noData:'暂无此产品'
  },
  message: {
    whether: "是否支付成功",
    zfsuccess: "支付成功",
    zfdestruction: "支付失败",
  },
  //顶部欢迎条
  headerTop: {
    wel: "您好，欢迎来到FSOM购物中心！",
    login: "登录与注册",
    msg: "消息中心",
    board: "留言板",
  },
  //带搜索的top
  header: {
    all: "全部",
    key: "输入关键字",
    home: "首页",
    sopC: "购物车",
    goods: "物品",
    user: "用户",
    tel: "热线电话",
    Mycart: "我的购物车",
    place: "提交订单",
    complete: "完成订单",
    returns: "返回",
  },
  // 公共tab切换
  tab: {
    footPrint: ["我的足迹"],
    Collection: ["我的收藏"],
    project: ["我的项目"],
    longrange: ["远程技术支持"],
  },
  // 关于我们
  aboutUS: {
    briefintroduction: "公司简介",
    idea: "公司理念",
    Mainbusiness: "主营业务",
    purpose: "我们的宗旨",
    cp:'公司简介',
    newForm:'新闻资讯',
		customer:'客服中心'
  },
  // 提示
  Tips: {
    perfect: "请完善信息",
    applysuc: "申请成功",
    num: "数量必须是整数",
    collectionsuc: "收藏成功",
    addsuc: "添加成功",
    sccancel: "是否确认取消收藏？",
    Tips: "提示",
    zjDel: "您是否要删除该足迹?",
    delsuc: "删除成功",
    qxDel: "取消删除",
    projectTips: "您确认取消该项目吗？",
    qxsuc: "取消成功",
    SubmitTips: "您确定要提交该项目吗?",
    Submitsue: "提交成功",
    telWrong: "您的手机号码填写有误",
    xmeditsuc: "项目编辑成功",
    Receiptsuc: "收货成功",
    Billingsuc: "开票成功",
    Aftersalestype: "请选择售后类型",
    Aftersalesdescription: "请输入售后描述",
    uploadsuc: "上传成功",
    upTips: "你最多只能选择一个文件",
    fillin: "请填写",
    out: "是否退出登录?",
    outsuc: "退出成功",
    qxordersuc: "您确认取消该订单吗？",
    confirm: "确认",
    cancel: "取消",
    modifysuc: "修改成功",
    mailbox: "请输入邮箱",
    code: "验证码已发送",
    txTips: "是否确认提现？",
    txsuc: "提现成功",
    txfail: "提现失败",
    setupsuc: "设置成功",
    paymentsuc: "支付成功",
    RMBaccount: "人民币账户余额不足",
    USDaccount: "美金账户余额不足",
    Tick: "请勾选FSOM隐私条款",
    registersuc: "注册成功",
    search: "搜索内容不能为空",
    shop: "请至少选择一件商品",
    dataTips: "您确认提交数据吗?",
    nojurisdiction: "没有下载权限",
  },
  // 修改个人资料
  modifyUser: {
    upload: "上传头像",
    fullname: "姓名",
    China: "中国",
    tel: "手机号",
    modify: "修改",
    Gender: "性别",
    male: "男",
    female: "女",
    region: "地区",
    company: "公司",
    preservation: "保存",
  },
  // 修改密码
  modifyPsd: {
    Tips: "温馨提示：密码请尽量复杂，8~20位，字母数字相结合",
    Original: "原密码",
    new: "新密码",
    confirm: "确认新密码",
    modify: "确认修改",
    rules: {
      pPassword: [
        {
          required: true,
          message: "请输入原密码",
          trigger: "blur",
        },
      ],
      nPassword: [
        {
          required: true,
          message: "请输入新密码",
          trigger: "blur",
        },
        {
          min: 8,
          max: 20,
          message: "长度在 8 到 20 个字符",
          trigger: "blur",
        },
      ],
      sPassword: [
        {
          required: true,
          message: "请确认新密码",
          trigger: "blur",
        },
      ],
    },
    msgTips: "确认密码与新密码不一致",
    modifysuc: "修改成功",
  },
  // 支付
  payment: {
    ordernumber: "订单号",
    Tips: "请您尽快支付",
    Totalamount: "总金额",
    Alipay: "支付宝",
    use: "支付就用支付宝",
    recommend: "推荐",
    payment: "支付",
    txt: "国际支付工具，每天可消费5万元",
    RMB: "人民币账户",
    balance: "余额支付",
    dollar: "美金账户",
    Paynow: "立即支付",
    setpassword: "设置支付密码",
    mailbox: "邮箱",
    inpmailbox: "请输入邮箱地址",
    zqmailbox: "请输入正确的邮箱地址",
    obtain: "获取验证码",
    send: "秒后发送",
    code: "验证码",
    input: "请输入",
    Paymentpassword: "支付密码",
    setup: "立即设置",
    inppassword: "输入支付密码",
    determine: "确定",
  },
  // 充值&提现
  Recharge: {
    title: "请您务必确认提现账号是否正确",
    Totalamount: "总金额",
    Recharge: "充值",
    Withdrawal: "提现",
    money: "金额",
    moneyinput: "请输入金额，单次最多50000",
    account: "提现账号",
    accountinput: "请输入提现账号",
    Alipay: "支付宝",
    txt: "支付就用支付宝",
    recommend: "推荐",
    payment: "支付",
    international: "国际支付工具",
    Paynow: "立即支付",
    withdrawal: "确认提现",
  },
  // 收货信息
  Receipt: {
    information: "新增收货人信息",
    name: "机构名称",
    consignee: "收货人",
    country: "国家/地区",
    address: "详细地址",
    Zipcode: "邮编",
    tel: "联系电话",
    occupation: "您的职业",
    choice: "请选择",
    operation: "操作",
    modify: "修改",
    delete: "删除",
    default: "默认地址",
    setup: "设为默认",
    newlyadded: "新增地址",
    my: "我的收货地址",
    close: "关闭",
    new: "新增",
    edit: "编辑",
    input: "请输入内容",
    Submit: "提交",
    dataTitleGroup: {
      mechanismName: "机构名称",
      contacts: "收货人",
      country: "国家/地区",
      address: "收货地址",
      zipCode: "邮编",
      contactPhone: "联系电话",
    },
    delTips: "此操作将删除该地址, 是否继续?",
    Tips: "提示",
    determine: "确定",
    cancel: "取消",
    delsuc: "删除成功!",
    defaultTips: "确定设为默认地址, 是否继续?",
    modifysuc: "修改成功!",
    SubmitTips: "您真的要提交吗?",
    editsue: "收货地址编辑成功！",
    newlybuildTips: "新建收货地址成功！",
  },
  // 购物车
  Shopping: {
    Allproducts: "全部商品",
    Total: "合计（不含运费)",
    spinformation: "商品信息",
    UnitPrice: "单价",
    number: "数量",
    money: "金额",
    operation: "操作",
    delete: "删除",
    Selectall: "全选",
    Selected: "已选商品",
    settlement: "结算",
  },
  //下单页面
  placeorder: {
    Shopping: "购物车",
    userinformation: "填写并核对收货人信息",
    shinformation: "收货信息",
    shaddress: "新增收货地址",
    mraddress: "默认地址",
    edit: "编辑",
    ddinformation: "确认订单信息",
    Nodata: "暂无数据",
    number: "编号",
    describe: "描述",
    use: "使用",
    element: "元",
    Creditdeduction: "积分抵扣",
    Modeofdelivery: "运送方式：普通配送 快递 免邮",
    Memberdiscount: "使用会员折扣",
    fracture: "折",
    Totalgoods: "商品合计（含运费）",
    Actualpayment: "实际付款",
    To: "寄送至",
    consignee: "收货人",
    Ordernow: "立即下单",
    newlyadded: "新增",
    Receivingaddress: "收货地址",
    close: "关闭",
    Pleaseenter: "请输入内容",
    Submit: "提交",
    thead: [
      {
        title: "商品信息",
        width: "col-9",
        align: "center",
      },
      {
        title: "单价",
        width: "col-4 weight-font",
        align: "center",
      },
      {
        title: "数量",
        width: "col-3 weight-font",
        align: "center",
      },
      {
        title: "金额",
        width: "col-4 weight-font",
        align: "center",
      },
    ],
  },
  // 注册
  register: {
    modify: "立即修改",
    forget: "忘记密码",
    Memberregistration: "会员注册",
    Existingaccount: "已有账号",
    Signinnow: "立即登录",
    name: "名",
    Pleaseenteraname: "请输入名",
    surname: "姓",
    Pleaseenterlastname: "请输入姓",
    Telephone: "电话",
    PleaseenterTel: "请输入电话",
    mailbox: "电子邮箱",
    SendCode: "发送验证码",
    sendout: "秒后发送",
    Pleaseentermailbox: "请输入电子邮箱",
    mailboxCode: "邮箱验证码",
    PleaseentermailboxCode: "请输入邮箱验证码",
    password: "密码",
    Pleaseenterpassword: "请输入密码",
    Reconfirm: "确认密码",
    Pleasereconfirm: "请再确认",
    country: "国家",
    Pleaseentercountry: "请输入国家",
    province: "省市",
    Pleaseenterprovince: "请输入省市",
    company: "公司/学习",
    Pleaseentercompany: "请输入公司/学习",
    Registernow: "立即注册",
    agree: "我已阅读并同意",
    privacy: "《FSOM隐私条款》",
  },
  // 登录
  Signin: {
    Signin: "登录与注册",
    account: "账号",
    mailbox: "请输入邮箱",
    password: "密码",
    VerificationCode: "验证码",
    login: "登录",
    Forgetpassword: "忘记密码",
    nomember: "您还不是会员",
    Registeredmember: "立即注册成为会员",
    Registernow: "立即注册",
    title: "专注于芯片领域",
    noaccount: "还没账号？",
    input: "请输入邮箱",
    tipsOut: "是否退出登录?",
    outSuc: "退出成功",
  },
  // 订单
  order: {
    tip:'删除提示',
    confirmTip:'你确认是否删除？',
    cancelOk:'删除成功',
    Paymenttime: "付款时间",
    Paid: "已付款",
    Putitaway: "收起",
    details: "详情",
    Cancelpayment: "您确认取消该订单吗？",
    title: "您确认立即付款吗？",
    Productnumber: "产品编号",
    Productdescription: "产品描述",
    UnitPrice: "单价",
    Purchasequantity: "购买数量",
    current: "当前订单状态",
    Totalamount: "订单总金额",
    contact: "联系客服",
    shinformation: "收货人信息",
    wlinformation: "物流信息",
    wlcompany: "物流公司",
    wlorderno: "物流单号",
    ddinformation: "订单信息",
    Creationtime: "创建时间",
    bystages: "分期付款",
    information: "商品信息",
    Price: "价格",
    integral: "积分",
    state: "订单状态",
    edit: "编辑",
    number: "订单编号",
    num: "数量",
    exchange: "换货申请中",
    returngoods: "退货/退款申请中",
    hcomplete: "换货已完成",
    tcomplete: "退货/退款已完成",
    Rejected: "售后已拒绝",
    Closed: "已关闭",
    payment: "立即付款",
    upcontract: "上传合同",
    Dcontract: "下载合同",
    Gcontract: "公司合同",
    Ycontract: "用户合同",
    Aftersales: "申请售后",
    Billing: "申请开票",
    Confirmreceipt: "确认收货",
    Corder: "取消订单",
    deletes: "删除订单",
    ApplyBilling: "申请开票",
    BillingType: "开票类型",
    domesticBilling: "国内开票",
    abroadBilling: "国外开票",
    periodsNum: "申请期数",
    corporatename: "公司名称",
    taxpayer: "纳税人识别号",
    address: "公司地址",
    tel: "公司电话",
    OpeningName: "开户行名称",
    OpeningAccount: "开户行账户",
    Applynow: "立即申请",
    up: "将文件拖到此处，或",
    clickUp: "点击上传",
    upTxt: "只能上传word文件或pdf文件，且不超过5M",
    Applysales: "申请售后",
    AftersalesType: "售后类型",
    Pleaseselect: "请选择",
    input: "请输入",
    AftersalesReason: "售后原因",
    Cancel: "取 消",
    determine: "确 定",
    d: "第",
    q: "期",
    typeList: ["成品订单", "样品订单", "定制订单"],
    rules: {
      resource: [
        {
          required: true,
          message: "请选择开票类型",
          trigger: "change",
        },
      ],
      // type: [{
      // 	type: 'array',
      // 	required: true,
      // 	message: '请至少选择一个活动性质',
      // 	trigger: 'change'
      // }],
      name: [
        {
          message: "请输入公司名称",
          required: true,
        },
      ],
      num: [
        {
          message: "请输入纳税人识别号",
          // required: true,
        },
      ],
      city: [
        {
          message: "请输入公司地址",
          required: true,
        },
      ],
      tel: [
        {
          message: "请输入公司电话",
          required: true,
        },
      ],
      kfhmc: [
        {
          message: "请输入开户行名称",
          required: true,
        },
      ],
      kfhzh: [
        {
          message: "请输入开户行账户",
          required: true,
        },
      ],
    },
    options: [
      {
        value: "1",
        label: "退货",
      },
      {
        value: "2",
        label: "换货",
      },
      {
        value: "3",
        label: "退款",
      },
    ],
    stateList: [
      [
        {
          text: "状态：",
          state: -1,
        },
        {
          text: "全部",
          state: "",
        },
        {
          text: "待付款",
          state: 1,
        },
        {
          text: "待发货",
          state: 2,
        },
        {
          text: "待收货",
          state: 3,
        },
        {
          text: "已完成",
          state: 4,
        },
        {
          text: "订单关闭",
          state: 5,
        },
        {
          text: "售后",
          state: 6,
        },
      ],
      [
        {
          text: "状态：",
          state: -1,
        },
        {
          text: "全部",
          state: "",
        },
        {
          text: "待审核",
          state: 0,
        },
        {
          text: "待发货",
          state: 1,
        },
        {
          text: "待收货",
          state: 2,
        },
        {
          text: "已完成",
          state: 3,
        },
        {
          text: "拒绝申请",
          state: 4,
        },
        {
          text: "已取消",
          state: 5,
        },
      ],
      [
        //0待审核 ，1待用户上传合同 2合同待审核 3待设置款项 4待付款 5待发货 6合同审核驳回 7订单审核驳回 8已完成 9已取消
        {
          text: "状态：",
          state: -1,
        },
        {
          text: "全部",
          state: "",
        },
        {
          text: "待审核",
          state: 0,
        },
        {
          text: "待上传合同",
          state: 1,
        },
        {
          text: "合同待审核",
          state: 2,
        },
        {
          text: "待设置款项",
          state: 3,
        },
        {
          text: "待付款",
          state: 4,
        },
        {
          text: "待发货/待收货",
          state: 5,
        },
        {
          text: "合同驳回",
          state: 6,
        },
        {
          text: "订单驳回",
          state: 7,
        },
        {
          text: "已完成",
          state: 8,
        },
        {
          text: "已取消",
          state: 9,
        },
        {
          text: "售后",
          state: 10,
        },
      ],
    ],
  },
  // 状态
  state: {
    Shipped: "已发货",
    payment: "待付款",
    delivergoods: "待发货",
    Distribution: "配送中",
    Completed: "已完成",
    close: "订单关闭",
    toexamine: "待审核",
    Receipt: "待收货",
    Receivedgoods: "已收货",
    Rejected: "已拒绝",
    Cancelled: "已取消",
    upload: "待上传合同",
    htToexamine: "合同待审核",
    setup: "待设置款项",
    htreject: "合同审核驳回",
    ddreject: "订单审核驳回",
    Submit: "待提交",
    Underreview: "审核中",
    Passed: "已通过",
  },
  // 远程技术
  technology: {
    english: "英文",
    chinese: "中文",
    video: "视频会议",
    tel: "电话",
    communicate: "线下沟通",
    no: "未受理",
    Accepted: "已受理",
    Completed: "已完成",
    Cancelled: "已取消",
    cancel: "取消",
    edit: "编辑",
    launch: "发起远程技术支持",
    noData: "暂未数据",
    longrange: "远程技术支持",
    close: "关闭",
    input: "请输入内容",
    choice: "请选择",
    Submit: "提交",
    thead: [
      {
        width: "col-3",
        align: "center",
        title: "问题",
      },
      {
        width: "col-3",
        align: "center",
        title: "时间",
      },
      {
        width: "col-3",
        align: "center",
        title: "沟通方式",
      },
      {
        width: "col-2",
        align: "center",
        title: "沟通语言",
      },
      {
        width: "col-3",
        align: "center",
        title: "备注",
      },
      {
        width: "col-2",
        align: "center",
        title: "状态",
      },
      {
        width: "col-4",
        align: "center",
        title: "编辑",
      },
    ],
    dataTitleGroup: {
      communication: "沟通方式",
      remark1: "你的问题",
      communicationRemark: "沟通备注",
      scheduled: "沟通时间",
      remark: "其他备注",
      language: "沟通语言",
    },
  },
  // 我的项目
  project: {
    submitted: "待提交",
    underReview: "审核中",
    Passed: "已通过",
    Rejected: "已拒绝",
    cancel: "取消",
    edit: "编辑",
    Submit: "提交",
    add: "新增我的项目",
    newlyadded: "新增",
    Myproject: "我的项目",
    close: "关闭",
    Pleaseenter: "请输入内容",
    thead: [
      {
        width: "col-4",
        align: "center",
        title: "项目名称",
      },
      {
        width: "col-4",
        align: "center",
        title: "联系电话",
      },
      {
        width: "col-4",
        align: "center",
        title: "项目描述",
      },
      {
        width: "col-4",
        align: "center",
        title: "项目状态",
      },
      {
        width: "col-4",
        align: "center",
        title: "编辑",
      },
    ],
    dataTitleGroup: {
      projectName: "项目名称",
      phone: "联系电话",
      projectDescribe: "项目描述",
    },
    dataGroup: {
      projectName: "项目名称",
      phone: "联系电话",
      projectDescribe: "项目描述",
    },
    cancelErr:'取消失败',
    hasCancel:'已取消提交项目'
  },
  // 商品详情
  shopDet: {
    Purchasequantity: "购买数量",
    see: "查看人民币价格",
    application: "产品参数",
    purchase: "立即购买",
    shoppingCart: "加入购物车",
    sample: "申请样品",
    consume: "消耗",
    integral: "积分",
    Collection: "收藏此商品",
    deletes: "删除足迹",
    cancel: "取消收藏",
    Documentname: "文档名称",
    description: "文档描述",
    size: "文件大小",
    time: "时间",
    download: "下载",
    consignee: "收货人",
    tel: "联系电话",
    address: "收货地址",
    apply: "立即申请",
    rules: {
      consignee: [
        {
          required: true,
          message: "请输入收货人",
          trigger: "blur",
        },
      ],
      tel: [
        {
          required: true,
          message: "请输入联系电话",
          trigger: "blur",
        },
      ],
      city: [
        {
          required: true,
          message: "请输入收货地址",
          trigger: "blur",
        },
      ],
      region: [
        {
          required: true,
          message: "请选择活动区域",
          trigger: "change",
        },
      ],
      resource: [
        {
          required: true,
          message: "请选择活动资源",
          trigger: "change",
        },
      ],
    },
  },
  //页面导航条
  nav: {
    home: "首页",
    menberCenter: "会员中心",
    proCenter: "产品中心",
    service: "定制服务",
    share: "技术分享",
    afterSale: "帮助中心",
    aboutUS: "关于我们",
  },
  //首页
  homePage: {
    product: "所有产品分类",
    hi: "欢迎来到FSOM",
    sign: "登录",
    register: "注册",
    newsflash: "FSOM快讯",
    more: "更多",
    footprint: "足迹",
    member: "会员",
    account: "账户",
    news: "消息",
    order: "订单",
    long_range: "远程",
    wallet: "钱包",
    project: "项目",
    Collection: "收藏",
    data: "资料",
    recommend: "推荐",
    Hot: "热门推荐",
    whole: "全部",
    Passive: "无源器件",
    Active: "有源器件",
    magnifier: "放大镜",
    chip: "外置芯片",
    Hots: "热卖中",
    Newproducts: "新品价",
    honor: "公司荣誉",
    course: "公司历程",
    partner: "合作伙伴",
    briefintroduction: "公司简介",
    MembershipCenter: "会员中心",
    PersonalCenter: "消息中心",
    kfTime: "客服在线（北京时间）",
    Telephone: "联系电话",
    PreSsale: "售前联系邮箱",
    AfterSales: "售后联系邮箱",
		all: '全部',
    hot: '热门推荐',
    more:'更多',
    solution:'解决方案',
		aboutUS:'关于FSOM',
    friend:'友情链接'
  },
  // 搜索
  search: {
    arr: ["全部", "产品", "文档", "资讯"],
    home: "首页",
    search: "搜索",
    product: "产品",
    file: "文档",
    information: "资讯",
    common: "共",
    result: "条结果",
    model: "型号",
    stock: "库存",
    Price: "价格",
    details: "详情",
    member: "会员下载",
    ordinary: "普通下载",
    Views: "浏览量",
    Download: "下载量",
    time: "上传时间",
    describe: "描述",
    thead: [
      {
        title: "商品信息",
        width: "col-8",
        align: "center",
      },
      {
        title: "价格",
        width: "col-4",
        align: "center",
      },
      {
        title: "操作",
        width: "col-8",
        align: "center",
      },
    ],
  },
  // 会员中心
  vip: {
    billingRecord: "开票记录",
    Cashier: "收银台",
    system: "系统",
    order: "订单",
    Company: "万",
    Account: "账户信息",
    vip: "会员等级",
    Receiving: "收货信息",
    personal: "个人资料",
    Changezf: "修改支付密码",
    Change: "修改密码",
    out: "退出登录",
    finished: "成品订单",
    sample: "样品订单",
    customized: "定制订单",
    whole: "查看全部",
    shop: "商品信息",
    Price: "价格",
    type: "订单状态",
    edit: "编辑",
    number: "订单编号",
    num: "数量",
    payment: "立即付款",
    cancel: "取消订单",
    news: "我的消息",
    available: "暂无数据",
    balance: "账户余额",
    balances: "余额",
    integral: "积分",
    footprint: "我的足迹",
    Collection: "我的收藏",
    technology: "远程技术支持",
    project: "我的项目",
    launch: "点击发起",
    no_project: "暂无项目",
  },
  // 技术分享
  tgshare: {
    title: "价值在于分享",
    txt: "致力于为工程师提供丰富的应用设计、电路图、应用方案、行业软件等资料",
    selection: "已选取",
    empty: "清空筛选",
    search: "搜索结果",
    strip: "条",
    classification: "文档分类",
    jurisdiction: "下载权限",
    member: "会员下载",
    ordinary: "普通下载",
    Views: "浏览量",
    Download: "下载量",
    Upload: "上传时间",
    tab: ["全部", "会员", "免费"],
    inp: "请输入资料名称",
  },
  // 售后服务
  service: {
    txt: "秉承客户至上的经营理念，拥有严密的管理和把控服务流程，严格按照服务标准竭诚为每一位客户提供至臻至善的解决方案。我们拥有一支高素质的客服顾问团队，为您提供7*24小时在线支持，最大限度的集中调配资源，确保每一个细节都照顾周到。我们推出全方位需求接收模式，专业技术团队全天候在线服务。客户可以通过电话咨询、邮箱、传真、QQ等多种服务响应渠道与FSOM服务工程师交流，无需排队等待，快速寻求解决方案。",
    apply: "申请售后",
    my: "我的售后",
  },
  //定制订单申请
  customizedApply: {
    productName: "产品名称",
    indexRequirement: "指标要求",
    sizeRequirement: "尺寸要求",
    demandQuantity: "需求数量",
    deliveryCycle: "交付周期",
    qualityGrade: "质量等级",
    weight: "重量(g)",
    installationMode: "安装方式",
    useEnvironment: "使用环境",
    otherProcessRequirements: "其他工艺要求",
    detailedDescription: "详细描述",
    sendAddress: "收货地址",
    contractStyle: "联系方式",
    receivingUser: "联系人",
    annexFile: "上传附件",
    confirmApply: "确认上传",
    remove: "移除",
    confirmSubmit: "您确认提交数据吗？",
    title: "提示",
    alertText: "申请成功，请等待平台审核",
    submitting: "正在提交数据",
    submiterr: "Failure to submit -- zh",
    uploadFile: "正在上传文件",
    uploadFileError: "文件上传失败",
  },
  //余额
  accountBalance: {
    apply: "申请提现",
    Withdrawalrefund: "提现退款",
    Accountrecharge: "账户充值",
    Paymentorder: "支付订单",
    Orderrefund: "订单退款",
    Sampleapplication: "样品申请",
    deduction: "购买商品抵扣",
    Closeorder: "关闭订单，退回积分",
    Completeorder: "完成订单赠送积分",
    my: "我的",
    wallet: "钱包",
    integral: "积分",
    Recharge: "充值",
    Withdrawal: "提现",
    bill: "我的账单",
    no: "暂无数据",
    balance: "人民币账户",
    Alipay: "支付宝",
    dollar: "美金账户",
    record: "提现记录",
    stay: "待审核",
    adopt: "审核通过",
    reject: "审核驳回",
    integralRecord: "积分记录",
    complete: "订单完成获得积分",
    typeList: ["我的钱包", "我的积分"],
    payHead: [
      {
        width: "col-4",
        align: "center",
        title: "创建时间",
      },
      {
        width: "col-4",
        align: "center",
        title: "金额",
      },
      {
        width: "col-4",
        align: "center",
        title: "交易类型",
      },
      {
        width: "col-5",
        align: "center",
        title: "订单号",
      },
      {
        width: "col-3",
        align: "center",
        title: "交易方式",
      },
    ],
    cashHead: [
      {
        width: "col-5",
        align: "center",
        title: "发起时间",
      },
      {
        width: "col-5",
        align: "center",
        title: "提现金额",
      },
      {
        width: "col-5",
        align: "center",
        title: "提现类型",
      },
      {
        width: "col-5",
        align: "center",
        title: "提现进度",
      },
    ],
    integralHead: [
      {
        width: "col-5",
        align: "center",
        title: "时间",
      },
      {
        width: "col-4",
        align: "center",
        title: "交易类型",
      },
      {
        width: "col-6",
        align: "center",
        title: "订单号",
      },
      {
        width: "col-5",
        align: "center",
        title: "积分",
      },
    ],
  },
  // 我的消息
  messageCenter: {
    communicate: "点击沟通",
    systemNotice: "系统通知",
    orderMessage: "订单消息",
    noData: "暂无数据",
    messageClass: {
      confirmMsg: "确认消息",
      payMsg: "支付消息",
      jumpMsg: "跳转消息",
      toPay: "去支付",
      clickConfirm: "点击确认",
      confirm: "已确认",
      clickJump: "点击跳转",
      confirmSuccess: "确认成功 ",
      confirmError: "确认失败 ",
    },
    loadMsgErr: "聊天组件加载失败",
    confirmSuccess: "确认成功",
    confirmError: "确认失败",
    confirmTitle: "此操作将确认消息内容, 是否继续？",
    loadErr: "加载失败",
    messageWindow: {
      closeWin: "关闭窗口",
      backService: "FSOM售后服务",
      title: "温馨提示：客服工作时间为：周一至周五9:00-18:00（北京时间）",
      clickLoadMore: "点击加载更多",
      loading: "加载中...",
      noMore: "没有更多了",
      placeholder: "请输入文字内容",
      send: "发送",
      loadError: "获取消息失败",
      sendError: "发送消息失败",
    },
  },
  product: {
    startBuy: "起购数量：",
    buy: "购买数量满",
    unitPrice: "单价",
    goodsLoop: "货期",
    price: "价格",
  },
  privacy: privacyCN,
  ...zhLocale,
};

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js